import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';

import { Section, SectionAlternate } from '@/src/components/organisms';
import { WsyiwygViewer } from '@/src/components/widgets';

import { Hero, SidebarNewsletter, SimilarStories } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  sidebarNewsletter: {
    padding: theme.spacing(3, 2),
    borderRadius: theme.spacing(2),
    background: theme.palette.alternate.dark,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },
}));

const SuccessCasesArticle = ({ doc = { data: {} }, latest = {} }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Hero
        cover={doc.data?.cover}
        title={doc.data?.title}
        subtitle={doc.data?.subtitle}
        author={doc.data?.author.data}
      />
      <Section>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <WsyiwygViewer>
              <RichText render={doc.data?.content} />
            </WsyiwygViewer>
          </Grid>
          <Grid item xs={12} md={4}>
            <SidebarNewsletter className={classes.sidebarNewsletter} />
          </Grid>
        </Grid>
      </Section>
      <SectionAlternate>
        <SimilarStories data={latest?.results} />
      </SectionAlternate>
    </div>
  );
};

SuccessCasesArticle.propTypes = {
  doc: PropTypes.object,
  latest: PropTypes.object,
};

export default SuccessCasesArticle;
